import { PROJECTS, COMPANY } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { Placeholder } from "@/components/Placeholder";
import { CTABand } from "@/components/CTABand";
import { PageHero, usePageMeta } from "@/components/PageHero";

const Projects = () => {
  usePageMeta(
    "Projects | Our Work | Bass Crane Service, Richmond VA",
    "Decades of safe, successful crane lifts and hauls across Richmond, VA and the Commonwealth of Virginia. Explore selected Bass Crane project work."
  );

  return (
    <div data-testid="projects-page">
      <PageHero
        eyebrow="Projects"
        titleLines={["Our", "Work"]}
        intro="Decades of safe, successful lifts across Richmond and the Commonwealth of Virginia, from residential removals to downtown steel erection."
        image="/images/header-projects.jpg"
        imageAlt="Bass Crane night lift beside a Virginia highway"
        testId="projects-hero"
      />

      {/* Project case studies and photos to be added */}
      <section className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-28 bg-white" data-testid="projects-gallery">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 grid-flow-dense">
          {PROJECTS.map((p, i) => (
            <Reveal
              key={i}
              delay={(i % 3) * 0.06}
              className={p.tall ? "sm:row-span-2 h-full" : ""}
            >
              <figure className="relative h-full group">
                <Placeholder
                  label={p.label}
                  src={p.image}
                  alt={p.alt}
                  className={p.tall ? "aspect-[3/4] sm:aspect-auto sm:h-full" : "aspect-[4/3]"}
                  parallax
                  index={`P-${String(i + 1).padStart(2, "0")}`}
                  testId={`project-tile-${i}`}
                />
                {p.title && (
                  <figcaption className="pointer-events-none absolute inset-x-0 bottom-0 p-5 pt-16 bg-gradient-to-t from-[#0F1D45]/90 via-[#0F1D45]/50 to-transparent">
                    <span className="block font-display text-lg md:text-xl uppercase text-white leading-tight">{p.title}</span>
                    <span className="mt-1 block font-mono-plex text-[11px] uppercase tracking-widest text-white/70">{p.meta}</span>
                  </figcaption>
                )}
              </figure>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABand
        heading="Your Job Next?"
        sub={`Call us anytime, 24/7, to put Bass Crane on your project.`}
      />
    </div>
  );
};

export default Projects;
